import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { LaunchDarklyService } from 'src/app/shared/services/launch-darkly.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as constants from '../../../../config/app-constants';
import { IncadaTenant } from '../../models/incada-tenant';
import { Organization } from '../../models/organization';
import { OrganizationService } from '../../services/organization.service';

@Component({
    selector: 'app-add-organization-dialog',
    templateUrl: './add-organization-dialog.component.html',
    styleUrls: ['./add-organization-dialog.component.scss'],
    standalone: false
})

export class AddOrganizationDialogComponent implements OnInit, OnDestroy {

  formGroup: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.maxLength(50)])
  });

  duplicateorg = false;
  duplicateorgname = '';
  showIncadaOption = false;
  onboardIncada = false;
  private selectedTenant: IncadaTenant | null = null;
  private flagSubscription: Subscription;

  constructor(
    public dialogRefNew: MatDialogRef<AddOrganizationDialogComponent>, private ngZone: NgZone,
    public dialog: MatDialog,
    private organizationService: OrganizationService,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private launchDarklyService: LaunchDarklyService
  ) { }

  ngOnInit() {
    this.flagSubscription = this.launchDarklyService.flagChange.subscribe((flags) => {
      this.showIncadaOption = flags['release-incada'] ?? false;
    });
  }

  ngOnDestroy() {
    if (this.flagSubscription) {
      this.flagSubscription.unsubscribe();
    }
  }

  onToggleIncada() {
    if (this.onboardIncada) {
      this.formGroup.addControl('incadaTenant', new FormControl('', [Validators.required]));
      this.formGroup.get('name').disable();
      this.formGroup.get('name').setValue('');
      this.selectedTenant = null;
    } else {
      this.formGroup.removeControl('incadaTenant');
      this.formGroup.get('name').enable();
      this.formGroup.get('name').setValue('');
      this.selectedTenant = null;
    }
  }

  onTenantSelected(tenant: IncadaTenant | null) {
    this.selectedTenant = tenant;
    if (tenant) {
      this.formGroup.get('name').setValue(tenant.name);
    } else {
      this.formGroup.get('name').setValue('');
    }
  }

  isLoad(event) {
    if (event != undefined && event.keyCode == 13) {
      this.addOrganization();
      return false;
    }
  }
  closePopup(val: any='') {
    this.formGroup.get('name').markAsUntouched();
    this.dialogRefNew.close(val);
    this.dialogRefNew.close(true);
    this.dialog.closeAll();
    this.ngZone.run(() => {
      this.dialogRefNew.close(val);
    });
  }

  validateForm() {
    if (!this.formGroup.valid) {
      this.formGroup.get('name').markAsTouched();
    }
  }

  addOrganization() {

    if (!this.formGroup.valid) {
      this.validateForm();
      return;
    }

    this.ngxLoader.start('add-organization-submit');
    const organization: Organization = this.formGroup.getRawValue();

    if (this.onboardIncada && this.selectedTenant) {
      organization.incadaId = this.selectedTenant.id;
      organization.incadaSlug = this.selectedTenant.slug;
      organization.incadaName = this.selectedTenant.name;
      organization.incadaRegion = this.selectedTenant.region;
    }

    this.organizationService.getOrganizationByName(organization.name)
      .subscribe((organizations) => {
        this.ngxLoader.stop('add-organization-submit');
        this.duplicateorg = true;
        this.duplicateorgname = organization.name;
      }, (res) => {
        this.duplicateorg = false;
        this.organizationService.saveOrganization(organization).subscribe(
          () => {
            this.ngxLoader.stop('add-organization-submit');
            this.closePopup('success');
            setTimeout(() => {
              this.toastService.openToast('New Organization Created', constants.ToastPanelType.done);
            }, 700);
          },
          ({ error }) => {
            this.ngxLoader.stop('add-organization-submit');
            const message = error.errors ? Object.values(error.errors)
              .map((e: string[]) => e.join('\n'))
              .join('\n') : error.error;
            this.toastService.openToast(message, constants.ToastPanelType.error);
          },
        );
      });
  }
}
